import { Input, Component, OnInit, OnChanges, SimpleChanges, SimpleChange, EventEmitter, Output } from '@angular/core';

export interface IPager {
    countOnPage: number;
    page: number;
    totalRow: number;
    totalPages: number;
    indexStart: number;
    indexEnd: number;
    labelPrev: string;
    labelNext: string;
    style: object;
    activeStyle: object;
}

class PageItem {
    constructor(id: number, label: string, isActive: boolean) {
        this.id = id;
        this.label = label;
        this.isActive = isActive;
    }
    label: string;
    id: number;
    isActive: boolean;
}

@Component({
    selector: 'pager',
    template: require('./pager.component.html'),
    styles: [require('./pager.component.css')]
})

export class PagerComponent implements OnChanges, OnInit  {
    @Input() pager: IPager;
    @Output() onPageChanged = new EventEmitter<number>();
    private pages:Array<PageItem> = [];
    
    ngOnInit(): void {
        
    }

    ngOnChanges(changes: SimpleChanges) {
        const pagerChange: SimpleChange = changes.pager;
        this.pages = [];
        this.pages.push(new PageItem(-2, (this.pager.labelPrev == null ? "<" : this.pager.labelPrev), false));

        let startPage = Math.max(1, this.pager.page - 2);
        let endPage = Math.min(this.pager.totalPages, this.pager.page + 2);

        const buttonsNumber = 5;

        if (this.pager.totalPages > buttonsNumber) {
            if (endPage - startPage + 1 < buttonsNumber) {
                if (startPage === 1) {
                    endPage = buttonsNumber;
                } else if (endPage === this.pager.totalPages) {
                    startPage = this.pager.totalPages - 4;
                }
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            this.pages.push(new PageItem(i, i.toString(), i === this.pager.page));
        }

        /*for (let i = 1; i <= pagerChange.currentValue.totalPages; i++) {
            this.pages.push(new PageItem(i, i.toString(), i == this.pager.page));
        }*/


        this.pages.push(new PageItem(-1, (this.pager.labelNext == null ? ">" : this.pager.labelNext), false));
    }

    changePage(id: number): void {
        //console.log('id: ', id.toString());
        if (!((id == -2 && this.pager.page == 1) || (id == -1 && this.pager.page == this.pager.totalPages) || (id == this.pager.page))) {
            if (id == -2)
                id = this.pager.page - 1;
            if (id == -1)
                id = this.pager.page + 1;
            this.onPageChanged.emit(id);
        }
        
    }

}